import React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import Main from '../Main';

const PrivateRoute = ({
  component: Component,
  isAuthenticated,
  user,
  ...rest
}) => (
  <Route
    {...rest}
    render={props => {
      if (isAuthenticated) {
        const roleId = user.role_id.toString();
        return rest.roles.includes(roleId) &&
          (!user.is_cx_agent || !rest.deny_cx_agents_access) ? (
          <Main>
            <Component {...props} />
          </Main>
        ) : (
          <Redirect
            to={{
              pathname: '/',
              state: { from: props.location }
            }}
          />
        );
      } else {
        return (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: props.location }
            }}
          />
        );
      }
    }}
  />
);

const mapStateToProps = state => {
  return {
    isAuthenticated: state.Auth.isAuthenticated,
    user: state.Auth.user
  };
};

export default connect(mapStateToProps)(React.memo(PrivateRoute));
